import React from "react";
import { FormField, CardSection, CheckboxItem } from "../../Common/FormComponents";

const BUILDING_TYPE_OPTIONS = [
  { value: "", label: "Select Type" },
  { value: "apartment_complex", label: "Apartment Complex" },
  { value: "commercial", label: "Commercial" },
  { value: "mixed_use", label: "Mixed Use" },
  { value: "townhouse_complex", label: "Townhouse Complex" },
  { value: "other", label: "Other" },
];

const AMENITIES_OPTIONS = [
  { value: "parking", label: "Parking" },
  { value: "garage", label: "Garage" },
  { value: "pool", label: "Pool" },
  { value: "gym", label: "Gym" },
  { value: "laundry", label: "Laundry" },
  { value: "dishwasher", label: "Dishwasher" },
  { value: "air_conditioning", label: "Air Conditioning" },
  { value: "heating", label: "Heating" },
  { value: "fireplace", label: "Fireplace" },
  { value: "balcony", label: "Balcony" },
  { value: "garden", label: "Garden" },
  { value: "pet_friendly", label: "Pet Friendly" },
  { value: "utilities_included", label: "Utilities Included" },
  { value: "internet", label: "Internet" },
  { value: "doorman", label: "Doorman" },
  { value: "hot_cold", label: "Hot & Cold" },
  { value: "semi_furnished", label: "Semi-furnished" },
  { value: "full_furnished", label: "Full-furnished" },
  { value: "unfurnished", label: "Unfurnished" },
];

const BuildingDetailsSection = ({ formData, handleInputChange, handleAmenitiesChange }) => (
  <>
    <CardSection title="Building Details">
      <div style={{ display: "grid", gap: "0.75rem" }}>
        <FormField label="Building Title" name="title" value={formData.title} onChange={handleInputChange} placeholder="Enter building title" />
        <FormField label="Building Description" name="description" as="textarea" rows={3} value={formData.description} onChange={handleInputChange} placeholder="Enter building description..." />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "0.75rem" }}>
          <FormField label="Total Units" name="totalUnits" type="number" value={formData.totalUnits} onChange={handleInputChange} min="0" placeholder="0" required />
          <FormField label="Number of Floors" name="floors" type="number" value={formData.floors} onChange={handleInputChange} min="0" placeholder="0" />
          <FormField label="Year Built" name="buildingYearBuilt" type="number" value={formData.buildingYearBuilt} onChange={handleInputChange} min="1800" max={new Date().getFullYear()} placeholder="YYYY" />
          <FormField label="Building Type" name="buildingType" type="select" value={formData.buildingType} onChange={handleInputChange} options={BUILDING_TYPE_OPTIONS} />
        </div>
      </div>
    </CardSection>

    <CardSection title="Building Amenities">
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "0.625rem" }}>
        {AMENITIES_OPTIONS.map((amenity) => (
          <CheckboxItem
            key={amenity.value}
            id={`amenity-${amenity.value}`}
            label={amenity.label}
            value={amenity.value}
            checked={formData.buildingAmenities?.includes(amenity.value)}
            onChange={handleAmenitiesChange}
          />
        ))}
      </div>
    </CardSection>
  </>
);

export default BuildingDetailsSection;
